import { FC } from 'react'
import { Select } from '../../SelectV2'
type Props = {
  name: string
  data?: any[]
  disabled?: boolean
  required?: boolean
  style?: any
  labelText?: React.ReactNode
  onChangeValue?: (e: any) => void
  getOptionLabel?: (option: any) => string
}
const SelectWrapper: FC<Props> = ({
  name,
  disabled,
  required,
  labelText,
  data = [],
  onChangeValue,
  style,
  getOptionLabel,
}) => {
  let classLabel = required ? 'required' : ''
  return (
    <div>
      <label className={classLabel}>{labelText}:</label>
      <Select
        name={name}
        disabled={disabled}
        data={data}
        style={style}
        onChangeValue={onChangeValue}
        getOptionLabel={getOptionLabel}
      />
    </div>
  )
}

export default SelectWrapper
